import { getDateFromISOString } from '@databases/utils/database/field-types/date';
import { parse } from 'date-fns';

type User = {
  accountId: string;
  _id: string;
};

export function isUserArray(value: unknown): value is User[] {
  return (
    Array.isArray(value) &&
    value.length > 0 &&
    value.every(
      (user) =>
        typeof user === 'object' &&
        'accountId' in user &&
        typeof user.accountId === 'string' &&
        '_id' in user &&
        typeof user._id === 'string'
    )
  );
}

export function isValidDate(date: unknown): date is Date {
  return date instanceof Date && !isNaN(date.getTime());
}

const isSafari = () =>
  navigator.userAgent.toLowerCase().includes('safari') &&
  !navigator.userAgent.toLowerCase().includes('chrome');

const SUPPORTED_DATE_FORMATS = [
  'yyyy-MM-dd', // databases
  'MM/dd/yyyy', // Google Sheets & Airtable
  'M/d/yyyy H:mm:ss', // Google Sheets date time
  'MMMM d, yyyy', // Notion
  'MMMM d, yyyy h:mm a', // Notion created at
  // other formats seen used by customers
  'yyyy/MM/dd',
  'MMM d, yyyy',
  'MM/dd/yyyy hh:mm a',
  'MM/dd/yyyy h:mm:ss',
  // Date constructor does not support these formats on Safari so we want to
  // treat as text field
  ...(!isSafari()
    ? [
        'dd/MMM/yy h:mm a', // Jira export
        'yyyy-MMM-dd',
        'yyyy-MMMM-dd',
        'MM-dd-yyyy',
      ]
    : []),
];

export function isConvertibleToDate(value: unknown): boolean {
  if (typeof value === 'string') {
    const referenceDate = new Date();
    if (getDateFromISOString(value) !== undefined) {
      return true;
    }
    return SUPPORTED_DATE_FORMATS.some((formatString) => {
      const parsedDate = parse(value as string, formatString, referenceDate);
      return isValidDate(parsedDate);
    });
  } else {
    const date = new Date(value as Date);
    return isValidDate(date);
  }
}
